import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const TrashIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 21.5 21.35"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 21.35)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M.75 4.75h20M12.7.75H8.66A1.35 1.35 0 0 0 7.29 2.1v2.26h6.77V2.1A1.35 1.35 0 0 0 12.71.75zM8.65 15.87V9.1M12.7 15.87V9.1"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M16.87 19.36a1.34 1.34 0 0 1-1.35 1.25H5.83a1.34 1.34 0 0 1-1.34-1.25l-1.26-15h14.9z"
        vectorEffect="non-scaling-stroke"
      />
    </SVG>
  );
};
